import type { IconData } from '@stacksjs/iconify-core'

export const databaseServer3Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 24.497c-7.69-.023-12.593-.176-15.433-.307c-2.596-.12-4.704-2.106-4.897-4.734c-.092-1.27-.17-2.82-.17-4.456s.078-3.186.17-4.456C1.863 7.916 3.971 5.93 6.567 5.81C9.646 5.668 15.15 5.5 24 5.5s14.354.168 17.433.31c2.596.12 4.705 2.106 4.897 4.734c.092 1.27.17 2.82.17 4.456s-.078 3.186-.17 4.456c-.192 2.628-2.301 4.614-4.897 4.734c-2.84.131-7.743.284-15.433.307v7.375A5.52 5.52 0 0 1 29.133 35h5.875a2 2 0 1 1 0 4h-5.875a5.502 5.502 0 0 1-10.25 0h-5.875a2 2 0 1 1 0-4h5.875A5.52 5.52 0 0 1 22 31.878zM16.5 15a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3H18a1.5 1.5 0 0 1-1.5-1.5M10 13.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 0 0-3z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default databaseServer3Solid
